import { List } from 'immutable';
import { handleActions } from 'redux-actions';

import { type resourceStoreTypes, resourceUpserters } from '../core';

import * as actions from './institutionsActions';
import { type Institution, type InstitutionStore, mkInstitutionsStore } from './institutionsTypes';

const institutionsReducer = handleActions<
  resourceStoreTypes.QcsSyncResourceStore<Institution, InstitutionStore>,
  ReturnType<typeof actions.getInstitutionResponse> | ReturnType<typeof actions.getPopularInstitutionsSuccess>
>(
  {
    [actions.getInstitutionResponse.type]: (state, { payload }) => {
      return resourceUpserters.upsertResource(state, payload?.resources?.[0]);
    },

    [actions.getPopularInstitutionsSuccess.type]: (state, { payload }) => {
      // have to manually set 'replaceCollection' to false
      // because upsertResources defaults to replacing if no getLastSyncDate provided

      let newState = resourceUpserters.upsertResources<Institution, InstitutionStore>(
        state,
        payload.set('replaceCollection', false),
      );
      newState = newState.set('popularIds', List(payload.resources.map((resource) => resource.id)));
      return newState;
    },
  },
  mkInstitutionsStore(),
);

export default institutionsReducer;
